import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./CheckboxInput.module.scss";

interface CheckboxInputProps extends React.ComponentPropsWithRef<"input"> {
	label: string;
	inputClassName?: string;
	labelClassName?: string;
}

export const CheckboxInput = forwardRef(
	(
		{ value, label, className, inputClassName, labelClassName, ...inputProps }: CheckboxInputProps,
		ref: React.ForwardedRef<HTMLInputElement>,
	) => {
		return (
			<label className={clsx(styles["checkbox"], className)}>
				<input
					ref={ref}
					value={value}
					type="checkbox"
					className={clsx(styles["checkbox__input"], inputClassName)}
					{...inputProps}
				/>

				<span className={clsx(styles["checkbox__label"], labelClassName)}>{label}</span>
			</label>
		);
	},
);
CheckboxInput.displayName = "CheckboxInput";
